import { Report } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { ReportTypeChip } from '../../../../../../components/ReportTypeChip';
import { UserLabel } from '../../../../../../components/users/UserLabel';
import { KeyValue } from '@app/core/components/KeyValue';

interface Props {
  report: Report;
}

export function BaseReportInfo({ report }: Props) {
  return (
    <div>
      <div>
        <KeyValue
          label={
            <FormattedMessage id="audit.reportsView.name" defaultMessage="Nombre del reporte" />
          }
        >
          {report.name}
        </KeyValue>
      </div>
      <div className="mt-4">
        <KeyValue label={<FormattedMessage id="audit.reportsView.type" defaultMessage="Tipo" />}>
          <ReportTypeChip reportType={report.type} />
        </KeyValue>
      </div>
      <div className="mt-4">
        <div className="row">
          <div className="col-4">
            <KeyValue
              label={
                <FormattedMessage
                  id="audit.reportsView.created"
                  defaultMessage="Fecha de creación"
                />
              }
            >
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <LDate
                  value={report.createdAt}
                  day="2-digit"
                  month="2-digit"
                  year="2-digit"
                  weekday="short"
                  className="text-capitalize"
                />
                <LTime value={report.createdAt} />
              </div>
            </KeyValue>
          </div>
          <div className="col-3">
            <KeyValue
              label={
                <FormattedMessage id="audit.reportsView.createdBy" defaultMessage="Creado por" />
              }
            >
              {report.createdBy ? (
                <UserLabel user={report.createdBy} />
              ) : (
                <span className="text-muted">
                  <FormattedMessage
                    id="audit.reportsView.createdByUnknown"
                    defaultMessage="Sin datos"
                  />
                </span>
              )}
            </KeyValue>
          </div>
        </div>
      </div>
    </div>
  );
}
